module.exports = __webpack_public_path__ + "static/media/photo4.56bd98cd.jpg";